import React from 'react';
import styled from 'styled-components';

import { LinkedBankSection } from 'src/components/wallet/linked-bank-section';
import { RecentActivitySection } from 'src/components/wallet/recent-activity-section';

import { WalletBalanceCard } from './wallet-balance-card';

export const WalletPanel = (): JSX.Element => (
  <WalletPanelContainer>
    <WalletBalanceCard />
    <LinkedBankSection />
    <RecentActivitySection />
  </WalletPanelContainer>
);

const WalletPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
`;
